require('./offers-group.scss');

import moment from 'moment-timezone';
import find from 'lodash.find';
import { selectVehicle, updateQueryAfterVehicleChange } from '../../core/actions/vehicles';
import { queryParamsLoaded } from '../../core/actions/data';
import {
      MEDIAQUERY_XSMALL,
      MEDIAQUERY_SMALL,
      MEDIAQUERY_MEDIUM,
      MEDIAQUERY_LARGE,
      MEDIAQUERY_XLARGE,
    } from '../../core/constants'; // eslint-disable-line max-len
import { REFERENCE_TIMEZONE } from '../../core/helpers/constants';
import { OFFERS, ALL_VEHICLES_FLAG } from '../../core/selectors/constants';
import { slugify } from '../../core/utils/formatter';
riot.tag2('offers-group', '<div class="offers-group-model {slugify(vehicle.model)}" if="{model !== ALL_VEHICLES_FLAG}"> <div class="offers-group-model-name-container"> <h2 class="offers-group-model-name">{vehicle.model}</h2> <acr-svg class="acr-svg-container" svg-arialabel="{vehicle.model} logo image" svg-id="{vehicle.model}-logo" svg-viewbox="0 0 200 34.2"></acr-svg> <span class="offers-group-model-filter acr-cta-text" data-automation="All-Offers-{vehicle.model}" if="{opts.type == \'single\'}" onclick="{selectVehicleModel}">{getLabel(\'labels.card.allOffersPrefix\')} {vehicle.model} {getLabel(\'labels.card.allOffersSuffix\')}</span> </div> <figure class="offers-group-model-container"> <img class="offers-vehicle-image" riot-src="{vehicleImg.url}" alt="{vehicleImg.alt}" height="{vehicleImg.height}"> </figure> <span class="offers-group-model-container-caption" if="{vehicleImg.url && vehicleImg.cutline}"> <raw-html content="{vehicleImg.cutline}"></raw-html> </span> </div> <div class="offers-card-group"> <h3 class="offers-group-all-vehicles-name" if="{model === ALL_VEHICLES_FLAG && offersGroup.length}">{labels.global.dropdown}</h3> <platform-offer-card each="{offer, i in offersGroup}" button-text="{getButtonLabel(offer)}" expiration="{offer.EndDate ? getLabel(\'labels.card.expirationPrefix\') + \' \' + offer.expirationDate : \'\'}" offer-type="{parent.parent.opts.offerType}" order-row="{parent.order}" id="offer_{offer.Id}_{parent.opts.type}" offer-id="{offer.Id}" legal="{offer.ShortDisclaimer}" link-text="{getLabel(\'labels.card.offerDetailsLink\')}" payment="{offer.payment}" term="{addDisclaimer(offer.term || offer.SpecialShortDescription, offer.TermsAndConditions)}" title="{offer.SalesProgramName}" type="{offer.SalesProgramTypeDescription}" is-special="{specialTypes.indexOf(offer.SalesProgramType) !== -1}" class="{\'offer-detail-item\': parent.opts.type != \'single\'} {offer.SalesProgramType} {checkSpecial(offer) ? getLabel(\'labels.card.specialClass\') : \'\'}" riot-style="order: {i + 1}; min-height: {platformCardHeight}" offer-detail-id="{parent.opts.type !== \'single\' ?                                              parent.opts.type + \'-\' + parent.parent.opts.offerType + \'-\' + vehicle.model :                                              \'\'}" tracking-json="{JSON.stringify(trackingJSON.offerDetail)}"> </platform-offer-card> <offer-detail type="{opts.type !== \'single\' ?                           opts.type + \'-\' + parent.opts.offerType + \'-\' + vehicle.model :                           \'\'}" offer-type="{parent.opts.offerType}" featured-single="{opts.type == \'detail\' ? \'true\' : \'\'}" if="{opts.type !== \'single\'}" vehicle-model="{vehicle.model}"></offer-detail> </div>', '', 'class="offers-group {opts.type ? \'type-\' + opts.type : \'\'} {\'offer-detail-item\': opts.type === \'single\'} {\'offers-group-all-vehicles\': model === ALL_VEHICLES_FLAG}" riot-style="order: {order}; background-image: url(\'{opts.type === \'detail\' ? backgroundImage : \'\'}\');" offer-detail-id="{opts.type !== \'single\' ? opts.type + \'-\' + vehicle.model : opts.type}"', function(opts) {

    const self = this;
    self.trackingJSON = require('../../data/tracking-data').default;

    self.slugify = slugify;

    const breakpoints = [
      {
        matchMedia: window.matchMedia(MEDIAQUERY_XSMALL),
        parameter: 'FeaturedCardBackgroundXSmall',
      },
      {
        matchMedia: window.matchMedia(MEDIAQUERY_SMALL),
        parameter: 'FeaturedCardBackgroundSmall',
      },
      {
        matchMedia: window.matchMedia(MEDIAQUERY_MEDIUM),
        parameter: 'FeaturedCardBackgroundMedium',
      },
      {
        matchMedia: window.matchMedia(MEDIAQUERY_LARGE),
        parameter: 'FeaturedCardBackgroundLarge',
      },
      {
        matchMedia: window.matchMedia(MEDIAQUERY_XLARGE),
        parameter: 'FeaturedCardBackgroundXLarge',
      },
    ];

    let isResizing = false;

    self.ALL_VEHICLES_FLAG = ALL_VEHICLES_FLAG;
    self.offerCardDataTrack = {
      cta: 'cta-get-offer',
      link: 'cta-click',
    };
    self.order = Object.keys(self.parent.offersByModel).indexOf(self.model) + 1;

    this.mixin('redux');
    self.mixin('bus');

    this.dispatchify({ selectVehicle });
    this.dispatchify({ updateQueryAfterVehicleChange });
    this.dispatchify({ queryParamsLoaded });

    function triggerAllModelOffersCtaTrackingClick() {
      const jsonData = JSON.parse(JSON.stringify(self.trackingJSON.allModelOffersCta));
      window.Acr.TrackingManager.clickActivity(jsonData);
    }

    function selectVehicleModel() {
      self.selectVehicle({ model: self.vehicle.model });
      self.updateQueryAfterVehicleChange({ model: self.vehicle.model });
      self.queryParamsLoaded({ defaultModelGroup: self.vehicle.model });
      self.bus.trigger(self.bus.EVENTS.MODEL.CHANGE, { newValue: self.vehicle.model });
      triggerAllModelOffersCtaTrackingClick();
    }

    function checkBackground() {
      const startDate = moment(
        self.getLabel('promotional.StartDate'),
        'MM/DD/YYYY HH:mm'
      ).tz(REFERENCE_TIMEZONE);
      const endDate = moment(
        self.getLabel('promotional.EndDate'),
        'MM/DD/YYYY HH:mm'
      ).tz(REFERENCE_TIMEZONE);
      const today = moment().tz(REFERENCE_TIMEZONE);

      function changeBackgroundMediaQuery(mediaQuery, imageParameter) {
        if (today > startDate && today < endDate && mediaQuery.matches) {
          self.backgroundImage = self.getLabel('promotional')[imageParameter].url;
        }

        self.update();
      }

      breakpoints.forEach((breakpoint) => {
        breakpoint.matchMedia.addListener((mediaQuery) => {
          changeBackgroundMediaQuery(mediaQuery, breakpoint.parameter);
        });

        changeBackgroundMediaQuery(breakpoint.matchMedia, breakpoint.parameter);
      });
    }

    function getButtonLabel(offer) {
      if (offer.SalesProgramType === OFFERS.TYPES.SPECIAL) {
        return null;
      }

      return offer.SalesProgramType === OFFERS.TYPES.HCPV
        ? self.getLabel('labels.card.viewInventory')
        : self.getLabel('labels.card.getThisButton');
    }

    function addDisclaimer(text, disclaimerCopy) {
      return text.replace(/\[([^)]+)\]/ig,
        `<a href="" data-copy="${disclaimerCopy}" data-disclaimer="$1">[$1]</a>`);
    }

    self.on('mount', () => {
      const hasBackground = breakpoints.some((breakpoint) => self.getLabel('promotional')[breakpoint.parameter]
        && self.getLabel('promotional')[breakpoint.parameter].url
        && self.getLabel('promotional')[breakpoint.parameter].url !== '');

      if (hasBackground) {
        checkBackground();
      }

      const $cardDetailButtons = self.root.querySelectorAll('platform-offer-card .offer-card-link');

      [].forEach.call($cardDetailButtons, ($button) => {
        $button.classList.add('show-details');
      });
    });

    function checkSpecial(offer) {
      let result = false;

      result = self.getLabel('specialTypes').reduce((last, type) => {
        let isSpecial = last;

        if (!isSpecial) {
          isSpecial = offer.SalesProgramType === type;
        }

        return isSpecial;
      }, result);

      return result;
    }

    this.selectVehicleModel = selectVehicleModel;
    this.getButtonLabel = getButtonLabel;
    this.addDisclaimer = addDisclaimer;
    this.checkSpecial = checkSpecial;

    function checkImageHeight(image) {
      let height = image.getBoundingClientRect().height;
      image.removeAttribute('style');

      if (height > 0) {
        setTimeout(() => {
          const width = image.getBoundingClientRect().width;
          const aspectRatio = image.naturalWidth / image.naturalHeight;

          height = width / aspectRatio;
          image.style.height = `${height}px`;
        }, 500);
      }

      isResizing = false;
    }

    function setImageHeight() {
      const image = self.root.querySelector('.offers-vehicle-image');
      const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

      if (isIE11 && image) {
        // We have to manually set the height due to a flexbox defect on IE11
        image.onload = () => {
          checkImageHeight(image);
          window.addEventListener('resize', () => {
            if (!isResizing) {
              isResizing = true;
              checkImageHeight(image);
            }
          });
        };
        checkImageHeight(image);
      }
    }

    this.on('update', () => {
      let offerType;
      let stockPhotoUrl = null;

      if (self.model) {
        self.vehicle = {
          model: self.model,
        };

        const selectedVehicle = find(
          self.getLabel('blades'),
          {
            offersModelGroupName: self.vehicle.model,
          }
        );

        setImageHeight();

        if (selectedVehicle && selectedVehicle.modelYear) {
          self.vehicle.year = selectedVehicle.modelYear;
        }

        if (selectedVehicle) {
          self.vehicleImg = {
            url: (selectedVehicle.offersImage) ? selectedVehicle.offersImage.url : false,
            alt: (selectedVehicle.offersImage) ? selectedVehicle.offersImage.altText : false,
            cutline: (selectedVehicle.offersDisclaimer
              && selectedVehicle.offersDisclaimer.description)
              ? selectedVehicle.offersDisclaimer.description : false,
          };
          offerType = self.parent.opts.offerType; // Offer type is used to check current tab
          // stockPhotoUrl is taken from the first offer that applies to the current vehicle
          stockPhotoUrl = self.offersGroup[0] && self.offersGroup[0].ModelStockPhotoLarge
            ? self.offersGroup[0].ModelStockPhotoLarge : false;
          // In order to show Stock Photo we need to verify:
          // 1) Current tab matches the target tab on window.offers.stockPhoto.stockPhotoTab
          // 2) Stock Photo overwrite is enabled under window.offers.stockPhoto.showStockPhoto
          // 3) The ModelStockPhotoLarge exists under the current offersGroup first offer
          if (self.stockPhoto && offerType === self.stockPhoto.stockPhotoTab
            && self.stockPhoto.showStockPhoto
            && stockPhotoUrl) {
            self.vehicleImg.url = stockPhotoUrl;
            self.vehicleImg.cutline = false;
          }
        }

        if (self.opts.type === 'special' && self.offersGroup.length
          && self.opts.allOffers && self.model in self.opts.allOffers) {
          self.offersGroup = self.opts.allOffers[self.model].slice(1);
        }
      }

      if (self.opts.type === 'detail' || self.opts.type === 'single') {
        self.offersGroup = [...self.offersGroup];
        self.offersGroup.length = 1;
      }
    });
});
